<!--
 * @Author: your name
 * @Date: 2022-03-03 09:53:15
 * @LastEditTime: 2022-03-16 17:57:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /demander-manage/src/views/orderManagement/components/detail/detail.vue
-->
<template>
  <div class="orderDetail-view">
    <header class="order-title">
      <span class="skip" @click="toOrder">订单管理</span>
      <span class="cutApart">></span>
      <span style="font-weight:400;">订单详情</span>
    </header>

    <main>
      <div class="topInfo">
        <div class="contentBox">
          <div class="title">
            <span class="line" /> <span>订单信息</span>
          </div>
          <div class="conten">
            <p><span class="title">订单编号</span>:<span class="text">{{ orderInfo.FOrderNo }}</span></p>
            <p><span class="title">下单时间</span>:<span class="text">{{ orderInfo.FCreateTime }}</span></p>
            <p><span class="title">收货人</span>:<span class="text">{{ orderInfo.FReceiver + ' ' + orderInfo.FReceiverPhoneNo }}</span></p>
            <p><span class="title">下单人</span>:<span class="text">{{ orderInfo.FUserName }}</span></p>
            <p><span class="title">收货地址</span>:<span class="text">{{ orderInfo.FReceiverAddress }}</span></p>
            <p><span class="title">订单备注</span>:<span class="text">{{ orderInfo.FOrderRemark }}</span></p>
          </div>
          <span class="status">
            {{ selectStatus[orderInfo.FOrderStatus] }}
          </span>
        </div>
        <div class="contentBox logisticsInfo">
          <div class="title">
            <span class="line" /> <span>物流信息</span>
          </div>
          <div v-if="afterSalesList.length" class="conten">
            <p><span class="title">{{ timeTitle[showAfterSales.FType] }}</span>:<span class="text">{{ showAfterSales.FConfirmTime }}</span></p>
            <p><span class="title">{{ personTitle[showAfterSales.FType] }}</span>:<span class="text">{{ showAfterSales.FConfirmUser }}</span></p>
            <p><span class="title">{{ remarkTitle[showAfterSales.FType] }}</span>:<span class="text">{{ showAfterSales.FRemark }}</span></p>
            <p><span class="title">{{ imageTitle[showAfterSales.FType] }}</span>:
              <span style="margin:8px 0 0 10px;">
                <el-carousel v-if="showAfterSales.FImagePath.length" height="90px">
                  <el-carousel-item style="transform: none;"  v-for="item in imageSplit(showAfterSales.FImagePath)" :key="item">
                    <!-- <img :src="item" alt=""> -->
                    <el-image
                      style="width: 204px; height: 90px"
                      :src="item"
                      @click="previewImg(item,imageSplit(showAfterSales.FImagePath))"
                    />
                  </el-carousel-item>
                </el-carousel>
              </span>
              <!-- <span v-for="(img,inx) in showAfterSales.FImagePath" :key="inx" style="margin:8px 0 0 10px;">
                <el-image
                  v-if="inx == 0"
                  style="width: 120px; height: 90px"
                  :src="img"
                  :preview-src-list="showAfterSales.FImagePath"
                />
              </span> -->
            </p>
          </div>
          <span v-if="afterSalesList.length" class="seeAll" @click="logisticsVisible = true"><svg-icon icon-class="seeAll" /> 查看全部</span>
        </div>
        <div class="contentBox approveInfo">
          <div class="title">
            <span class="line" /> <span>审批信息</span>
          </div>
          <div class="conten">
            <div v-for="(t,i) in FApprovalList" :key="i" class="approve">
              <p class="text">{{ (t.FIsCurrentAppr && t.FStatus === 0) ? '审核中' : stepsText[t.FStatus] }}</p>
              <div class="icon">
                <div><i class="el-icon-success" /></div>
                <div v-if="i !== FApprovalList.length - 1" class="line" />
              </div>
              <div class="person">{{ t.FApprovalName }}</div>
              <div class="time">{{ t.FApprovalTime }}</div>
            </div>
          </div>
        </div>
        <div class="contentBox approveInfo">
          <div class="title">
            <span class="line" /> <span>发票信息</span>
          </div>
          <div class="conten">
            <div class="billTitle">
              <span v-if="invoiceUnit.FInvoiceUnitName" class="edit" @click="editVisible = true"><i class="el-icon-edit" /> 修改</span>
              <p><span class="title">发票抬头</span>:<span class="text">{{ invoiceUnit.FInvoiceUnitName }}</span></p>
              <p><span class="title">税号</span>:<span class="text">{{ invoiceUnit.FTaxNo }}</span></p>
              <p><span class="title">开户银行</span>:<span class="text">{{ invoiceUnit.FBank }}</span></p>
              <p><span class="title">银行账户</span>:<span class="text">{{ invoiceUnit.FAccountNo }}</span></p>
            </div>
            <div class="billInfo">
              <p><span class="title">发票号码</span>:<span class="text" /></p>
              <p><span class="title">开票时间</span>:<span class="text" /></p>
              <p><span class="title">开票人</span>:<span class="text" /></p>
              <p><span class="title">发票登记时间</span>:<span class="text" /></p>
              <p><span class="title">发票图片</span>:<span class="text" /></p>
            </div>
          </div>
        </div>
      </div>
      <div class="contentBox afterSalses">
        <div class="title">
          <span class="line" /> <span>售后信息</span>
        </div>
        <div class="content">
          <el-table
            class="afterTable"
            :data="afterSales"
            style="width: 100%"
            :header-cell-style="{background:'#F2F2F2',color:'#666666',height:'36px',fontWeight:'400'}"
          >
            <el-table-column
              prop="OrderAfterSaleFOrderNo"
              label="退货单号"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FApplyUser"
              label="发起人"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FApplyTime"
              label="发起时间"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FRefundTime"
              label="处理时间"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FStockName"
              label="商品名称"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FReturnQuanty"
              label="退货数量"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FRefundAmount"
              label="退货金额"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span style="font-weight:bold;">{{ scope.row.FRefundAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="FApplyUser"
              label="退货人"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FRefundUser"
              label="退款人"
              show-overflow-tooltip
            />
            <el-table-column
              prop="FDealStatus"
              label="售后状态"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span style="font-weight:bold;">
                  <span v-if="scope.row.FDealStatus == 0">处理中</span>
                  <span v-if="scope.row.FDealStatus == 1 || scope.row.FDealStatus == 3">售后完成</span>
                  <span v-if="scope.row.FDealStatus == 2 || scope.row.FDealStatus == 4">售后拒绝</span>
                  <span v-if="scope.row.FDealStatus == 5">用户取消</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="FDealTime"
              label="完成时间"
              show-overflow-tooltip
            />
            <el-table-column
              prop="address"
              label="操作"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.FDealStatus == 0" class="closeAfter" @click="closeAfter(scope.row)">取消售后</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="contentBox orderList afterSalses">
        <el-table
          :data="detailList"
          border
          show-summary
          :summary-method="getSummaries"
          style="width: 100%;margin-top:30px"
          :header-cell-style="{background:'#F5F5F5',color:'#666666',fontWeight:'400'}"
        >
          <el-table-column
            prop="date"
            label="商品"
            width="550"
            align="center"
          >
            <template slot-scope="scope">
              <div class="goods">
                <div class="goodsImg">
                  <el-image
                    style="width: 107px; height: 107px"
                    :src="scope.row.FStockImagePath"
                    :preview-src-list="[scope.row.FStockImagePath]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline" />
                    </div>
                  </el-image>
                </div>
                <div class="goodsInfo">
                  <div class="goodsName"><span
                    @click="toDetail(scope.row,item)"
                  >{{ scope.row.FStockName }}</span></div>
                  <div class="goodsExplain">
                    <div>
                      订货编码：
                      <span v-if="scope.row.FStockShortCode" class="code" @click="copyCode(scope.row.FStockShortCode)">{{ scope.row.FStockShortCode }}<i class="el-icon-document-copy" /></span>
                    </div>
                    <div>
                      需方编码：
                      <span v-if="scope.row.FDemandStcokCode" class="code" @click="copyCode(scope.row.FDemandStcokCode)">{{ scope.row.FDemandStcokCode }}<i class="el-icon-document-copy" /></span>
                    </div>
                    <div>
                      明细备注：
                      <el-popover
                        v-if="scope.row.fDetailRemark"
                        placement="top-start"
                        width="200"
                        trigger="hover"
                        :content="scope.row.fDetailRemark"
                      >
                        <i
                          slot="reference"
                          style="color:#F5783C; "
                          class="el-icon-warning-outline"
                        />
                      </el-popover>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="单价/数量" align="center" :resizable="false" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="FPriceShow" class="price">
                ￥{{ scope.row.FTotalPrice }}
                <span style="margin:0 5px;">
                  X
                </span>
                <span>
                  {{ scope.row.FQuanty }}
                  <span v-if="scope.row.FMeasurement">{{ scope.row.FMeasurement }}</span>
                </span>
              </div>
              <div v-else id="noShowPrice">
                <span>￥</span>价格不可见
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="FReturnQuanty"
            label="退货数量"
            align="center"
          />
          <el-table-column
            prop="FReturnAmount"
            label="退货金额"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="FPriceShow" style="font-weight:bold;">
                ￥{{ scope.row.FReturnAmount||0 }}元
              </span>
              <div v-else id="noShowPrice">
                <span>￥</span>价格不可见
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="订单金额"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="FPriceShow" style="font-weight:bold;">
                ￥{{ scope.row.FTotalAmount||0 }}
              </span>
              <div v-else id="noShowPrice">
                <span>￥</span>价格不可见
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop=""
            label="实付金额"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="FPriceShow" style="font-weight:bold;">
                ￥{{ (Number(scope.row.FTotalAmount) - Number(scope.row.FReturnAmount)).toFixed(2) }}元
              </span>
              <div v-else id="noShowPrice">
                <span>￥</span>价格不可见
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </main>

    <!-- <div class="order-money">订单金额：
      <template v-if="FPriceShow"><span>{{ sum }}</span>元</template>
      <span v-else id="noShowPrice" style="margin:0;">
        <span style="margin:0;">￥</span>价格不可见
      </span>
    </div> -->

    <logistics
      :logistics-visible="logisticsVisible"
      :after-sales-list="afterSalesList"
      @close="logisticsVisible = false"
    />

    <tipsDia
      :tip-visible="tipVisible"
      :tip-type="tipType"
      @closeTips="tipVisible = false"
      @cfmTips="cfmTips"
    />
    <editBill
      :order-id="fid"
      :invoice-unit="invoiceUnit"
      :edit-visible="editVisible"
      @closeEdit="editVisible = false"
      @cfmEdit="cfmEdit"
    />
  </div>
</template>

<script>
import { orderDetail } from '@/api/order.js'
import logistics from './logisticsInfo.vue'
import tipsDia from '../order/tips.vue'
import editBill from './editBill.vue'
import request from '@/utils/request.js'
import { Stream } from 'stream'
export default {
  components: {
    logistics,
    tipsDia,
    editBill
  },
  props: {
    fid: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      editVisible: false,
      invoiceUnit: {
        FAccountNo: '',
        FBank: '',
        FInvoiceUnitName: '',
        FTaxNo: ''
      },
      afterSaleRow: null,
      tipType: 2,
      tipVisible: false,
      logisticsVisible: false,
      showAfterSales: {
        FConfirmTime: '',
        FConfirmUser: '',
        FImagePath: [],
        FRemark: '',
        FType: ''
      },
      afterSalesList: [],
      value: 4,
      colors: ['#EB4655', '#EB4655', '#EB4655'],
      details: true,
      detailList: [],
      orderInfo: {
        FReceiverPhoneNo: '',
        FReceiver: ''
      },
      afterSales: [],
      sendStatus: ['未发货', '已发货', '已送达'],
      selectStatus: [
        '待付款',
        '待接单',
        '已取消',
        '待发货',
        '待收货',
        '已完成'
      ],
      showFAbstract: '',
      FAbstract: '',
      refuseVisible: false,
      FNextStep: '',
      FApprovalList: [],
      FApplyAcount: '',
      FApprovalStatus: null,
      boxStyle: [
        'approvalBody',
        'approvalBody underReview',
        'approvalBody refuse',
        'approvalBody adopt'
      ],
      stepsStatus: [
        'process',
        'error',
        'success',
        'error'
      ],
      stepsText: {
        0: '待审核',
        1: '已拒绝',
        2: '已通过',
        3: ' ',
        '-1': '已通过'
      },
      approvalStatus: [
        '待审核',
        '审核中',
        '已拒绝',
        '已通过'
      ],
      description: [
        '一级审批',
        '二级审批',
        '三级审批',
        '四级审批',
        '五极审批'
      ],
      timeTitle: {
        0: '发货时间',
        1: '平台收货时间',
        2: '平台发货时间',
        3: '平台代签时间',
        4: '收货时间'
      },
      remarkTitle: {
        0: '发货备注',
        1: '平台收货备注',
        2: '平台发货备注',
        3: '平台代签备注',
        4: '收货备注'
      },
      personTitle: {
        0: '发货人',
        1: '平台收货人',
        2: '平台发货人',
        3: '平台代签人',
        4: '收货人'
      },
      imageTitle: {
        0: '发货图片',
        1: '平台收货图片',
        2: '平台发货图片',
        3: '代签凭证',
        4: '收货图片'
      },
      FPriceShow: 0
    }
  },
  computed: {
    sum() {
      let sum = 0
      this.detailList.forEach(item => {
        sum += (item.FTotalAmount - Number(item.FReturnAmount))
      })
      return sum.toFixed(2)
    }
  },
  watch: {

  },
  created() {
    const userInfor = localStorage.getItem('userInfo')
    userInfor && (this.FPriceShow = JSON.parse(userInfor).FPriceShow)
    this.orderDetails()
    document.documentElement.scrollTop = 0;
  },
  methods: {
    previewImg(src="",arr=[]){
        console.log(this,arr)
        
        this.$global_img.previewSC(src,arr,0.7)
       
    },
    cfmEdit(val) {
      for (const key in this.invoiceUnit) {
        this.invoiceUnit[key] = val[key]
      }
      this.editVisible = false
    },
    imageSplit([str]) {
      if (typeof str === 'string') return str.split(';')
      return str
    },
    cfmTips() {
      request({
        url: `/mall/mallmanage/demandOrder/cancelAfterSale?id=${this.afterSaleRow.FAfterSaleID}`,
        method: 'post'
      })
        .then(res => {
          if (res.result) {
            this.$message.success(res.msg)
            this.afterSaleRow.FDealStatus = 5
            this.tipVisible = false
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      let n1 = 0
      let n2 = 0
      let n3 = 0
      this.detailList.forEach(t => {
        n1 += t.FReturnAmount
        n2 += t.FTotalAmount
      })
      n3 = n2 - n1
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计：'
        } else if (index === 3) {
          sums[index] = '￥' + n1.toFixed(2)
        } else if (index === 4) {
          sums[index] = '￥' + n2.toFixed(2)
        } else if (index === 5) {
          sums[index] = '￥' + n3.toFixed(2)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    toDetail(row, item) {
      if (!row.IsDirectoryPool) return
      if (row.FShelfed === 0) {
        return this.$message.error('该商品未上架')
      }
      if (row.FShelfed === 2) {
        return this.$message.error('该商品已下架')
      }
      if (!row.isChange) {
        this.$router.push({
          path: '/store/details',
          query: {
            mallstorestockFId: row.FStoreStockID,
            shopid: item.fmallStoreId
          }
        })
      }
    },
    closeAfter(row) {
      this.afterSaleRow = row
      this.tipVisible = true
    //   this.FAfterSaleID = row.FAfterSaleID
    },
    toOrder() {
      this.$router.push({
        name: 'MyOrderManagement'
      })
      this.details = false
      this.$emit('onTapOrderDetail', this.details)
    //   console.log(this.$route.query.orderStatus)
    //   this.$router.push({
    //     name: 'MyOrderManagement',
    //     params: {
    //       orderStatus: this.$route.query.orderStatus
    //     }
    //   })
    },
    orderDetails() {
      const params = new URLSearchParams()
      params.append('fid', this.fid)
      orderDetail(params)
        .then(res => {
          this.invoiceUnit = res.invoiceUnit || {}
          this.invoiceUnit.FBuyDepartID = res.details[0].FBuyDepartID
          this.invoiceUnit.FBuyDepartName = res.details[0].FBuyDepartName
          this.afterSalesList = res.transferInfo || []
          if (this.afterSalesList.length) {
            this.afterSalesList.forEach(t => {
              t.FImagePath = t.FImagePath ? t.FImagePath.split(',') : []
            })
            this.showAfterSales = this.afterSalesList[0]
          }
          this.detailList = res.details
          this.orderInfo = res.orderInfo
          this.afterSales = res.afterSales
          const { FApplyAcount, FApprovalList, FApprovalStatus, FNextStep } = res.approvalInfo || {}
          this.FApprovalStatus = FApprovalStatus
          this.FApplyAcount = FApplyAcount
          let isRefuse = false
          FApprovalList && FApprovalList.forEach(t => {
            if (isRefuse) {
              t.FStatus = 3
            }
            if (t.FStatus === 1) {
              isRefuse = true
            }
          })
          this.FApprovalList = FApprovalList
          this.FNextStep = FNextStep
          if (FApprovalStatus === 2) {
            this.FApprovalList && this.FApprovalList.forEach(item => {
              if (item.FStatus === 1) {
                this.showFAbstract = item.FAbstract
              }
            })
          }
        })
    },
    // onTapBackOrderList() {
    //   this.$router.back()
    // }
    // 点击查看详情
    onTapOrderDetail() {
      this.details = false
      this.$emit('onTapOrderDetail', this.details)
    }
  }
}
</script>

<style lang="scss">
  .title-text {
     cursor: pointer;
  }
  .orderDetail-view{
      font-family: YaHei;
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 50px;
    box-shadow: 0px 0px 10px 0px rgba(236, 33, 45, 0.1);
    main {
        .topInfo {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }

        .logisticsInfo {
            position: relative;
            .conten {
                .title {
                    width: 95px !important;
                }
            }
            .seeAll {
                cursor: pointer;
                position: absolute;
                right: 38px;
                bottom: 12px;
                font-size: 14px;
                color: #EC212D;
                .svg-icon {
                    margin-right: 3px;
                }
            }
        }
        .contentBox {
            position: relative;
            width: 49.6%;
            height: 254px;
            background: #FFFFFF;
            margin-top: 12px;
            padding: 17px 0 0 32px;
            .status {
                position: absolute;
                right: 48px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 36px;
                color: #333333;
                font-weight: bold;
            }
            .title {
                display: flex;
                align-items: center;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                    .line {
                        display: inline-block;
                        width: 4px;
                        height: 18px;
                        background-color: #EC212D;
                        margin-right: 10px;
                    }
            }
            .conten {
                margin-top: 7px;
                .el-carousel {
                    width: 204px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                p {
                    display: flex;
                    line-height: 33px;
                    span {
                        display: inline-block;
                        font-size: 14px;
                        color: #777;
                        font-weight: 400;
                        overflow: hidden;
                    }
                    .title {
                      flex:none;
                        width: 62px;
                        text-align: justify;
                        text-justify: distribute-all-lines;
                        text-align-last: justify;
                        vertical-align: top;
                    }
                    .text {
                        width: 655px;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        // color: #b18e8e;
                        color: #333333;
                        margin-left: 10px;
                    }
                }
            }
        }
        .approveInfo {
            height: 455px;
            .conten {
                margin-top: 15px;
                .billTitle {
                    position: relative;
                    width: 379px;
                    height: 150px;
                    background-image: url('../../../../../assets/images/bill.png');
                    padding: 9px 28px;
                    .title {
                        width: 62px;
                    }
                    .text {
                        width: 240px;
                        margin-left: 20px;
                    }
                    .edit {
                        caret-color: transparent;
                        cursor: pointer;
                        position: absolute;
                        right: -62px;
                        top: 15px;
                        font-size: 14px;
                        color: #EC212D;
                        i {
                            margin-right: 3px;
                        }
                    }
                }
                .billInfo {
                    margin-top: 10px;
                    .title {
                        width: 90px;
                    }
                    .text {
                        width: 600px;
                        margin-left: 20px;
                    }
                }
                .approve {
                    display: flex;
                    .text {
                        color: #2EB034;
                        font-size: 14px;
                        line-height: 20px;
                    }
                    .person {
                        font-size: 16px;
                        color: #333333;
                        font-weight: bold;
                        width: 152px;
                        padding-right: 10px;
                    }
                    .time {
                        font-size: 14px;
                        color: #888888;
                    }
                    .icon {
                        color: #2EB034;
                        margin: 0 33px 0 24px;
                        i {
                            font-size: 22px;
                        }
                        .line {
                            position: relative;
                            top: -2px;
                            left: 50%;
                            transform: translateX(-50%);
                            width: 1px;
                            height: 66px;
                            background-color: #25C66D;
                        }
                    }
                }
            }
        }
        .afterSalses {
            width: 100% ;
            height: auto ;
            padding-bottom: 20px;
            .content {
                margin-top: 15px;
                .afterTable {
                    .closeAfter {
                        cursor: pointer;
                        &:hover {
                            color: #EC212D;
                        }
                    }
                }
                .el-table__body-wrapper {
                    border-left: 1px solid #EBEEF5;
                    border-right: 1px solid #EBEEF5;
                }
            }

        }
    }

    .order-title {
        background-color: #fff;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        padding-left: 32px;
        .skip {
            cursor: pointer;
            font-weight: bold;
        }
        .cutApart {
            font-weight: bold;
            margin: 0 5px;
        }
        span {

        }
    }
    #noShowPrice {
        display: inline-block;
        text-align: center;
        height: 26px;
        line-height: 26px;
        padding: 0 5px;
        font-size: 14px;
        color: #ec2631;
        // background: #fbd3d5;
        width: 100px;
        margin: 0 auto;
        span {
            font-size: 12px;
        }
    }
    .noImage {
      width: 67px;
      height: 66px;
      line-height: 66px;
      text-align: center;
      background: #f5f7fa;
      font-size: 12px;
    }
    .order-status{
      width: 100%;
      height: 58px;
      background: #FDF5F6;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 16px 10px;
      .text{
        font-size: 14px;
        font-family: SimSun;
        font-weight: 400;
        color: #666666;
        span{
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
      }
      .tips{
        display: flex;
        .tips-left{
          width: 55px;
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: SimSun;
          font-weight: 400;
          color: #FF812C;
          span{
            margin-left: 5px;
          }
        }
        .tips-right{
          font-size: 12px;
          font-family: SimSun;
          font-weight: 400;
          color: #FF812C;
          margin-top: 10px;
          p{
            margin-top: 5px;
          }
        }
      }
    }
    .logisticsInformation {
            border-top: 2px dashed #EDEDED;
    }
    .detail-item{
      width: 100%;
      min-height: 100px;
      .process-box {
          display: flex;
          height: 170px;
          padding: 0 21px;
          .process-left {
              width: 225px;
              height: 100%;
              padding-top: 50px;
              border-right: 2px dashed #EDEDED;
              div {
                  text-align: center;
              }
              .left-top {
                  font-size: 18px;
                  color: #666971;
              }
              .left-right {
                  font-size: 20px;
                  color: #5BD372;
                  font-weight: 800;
                  margin-top: 15px;
              }
          }
          .process-right {
              width: 100%;
              padding: 0 130px;
              .steps-box {
                margin-top: 42px;
                .time-name {
                    max-width: 180px;
                }
                 .positon-text {
                    .el-step__description {
                        position: relative;
                        top: 38px;
                    }
                }
                .el-step__description {
                    color: #81879D !important;
                }
                .is-success {
                    color: #5BD372;
                    border-color: #5BD372;
                    .el-step__line {
                        background-color: #5BD372;
                    }
                }
                .is-finish {
                    color: #5BD372;
                    border-color: #5BD372;
                    .el-step__line {
                        background-color: #5BD372;
                    }
                }
                .is-wait {
                    color: #5B9EE6;
                    .is-text {
                        border-color: #5B9EE6;
                    }
                    .el-step__line {
                        background-color: #5B9EE6;
                    }
                }
                .is-process {
                    color: #FFAA47;
                    .is-text {
                        border-color: #FFAA47;
                    }
                    .el-step__line {
                        background-color: #FFAA47;
                    }
                }
                .is-error {
                    color: #EC212D;
                    .is-text {
                        border-color: #EC212D;
                    }
                    .el-step__line {
                        background-color: #EC212D;
                    }
                }
                .process-time {
                    display: flex;
                    width: 100%;
                    height: 25px;
                    div {
                    position: relative;
                    top: 6px;
                    left: 8px;
                    text-align: center;
                    font-size: 14px;
                    color: #A0A6BB;
                    }
                }
                .process-name {
                    display: flex;
                    width: 100%;
                    font-size: 16px;
                    color: #595C65;
                }
            }
          }
      }
      .item-title{
        width: 96%;
        height: 50px;
        display: flex;
        align-items: center;
        // justify-content: center;
        font-size: 18px;
        font-family: SimSun;
        font-weight: 400;
        color: #999999;
        margin-left: 21px;
        border-bottom: 5px dashed #999;
      }
      .item{
        // display: flex;
        box-sizing: border-box;
        padding: 0 21px;
        // flex-wrap: wrap;
        font-size: 14px;
        font-family: SimSun;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
        div{
        //   height: 35px;
          line-height: 35px;
        }
        .img-box {
            div {
                height: 100px;
            }
        }
      }
      .afterSale {
            position: relative;
            border: 1px solid #000;
            margin: 10px 21px 0;
            .complete {
                position: absolute;
                right: 0;
                top: 24px;
                width: 75px;
                height: 26px;
                line-height: 26px;
                background: #EC212D;
                color: #fff;
                text-align: center;
                border-radius: 5px;
                transform: rotate(45deg);
            }
      }
      .line{
        height: 1px;
        border: 1px dashed #000000;
        opacity: 0.1;
        margin-top: 14px;
      }
    }

  .orderList{
    width: 100%;
    min-height: 100px;
    .el-table__footer-wrapper {
        .has-gutter {
            tr td {
                background-color: #fff;
                &:first-child {
                    padding-left: 36px;
                    text-align: left;
                    border-right: 0;
                }
                &:nth-child(2) {
                    border-right: 0;
                }
                &:nth-child(n+3) {
                    .cell {
                        color: #EC212D;
                        font-weight: bold;
                    }
                }
                // &:nth-last-child(n+3) {
                //     border-right: 0;
                // }
            }
        }
    }
.goods {
            min-width: 550px;
            display: flex;
            box-sizing: border-box;
            padding: 10px 20px 10px 10px;

            .goodsImg {
                width: 107px;
                height: 106px;
                margin-right: 13px;

                img {
                    width: 107px;
                    height: 107px;
                }

                .el-image {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #f5f7fa;
                }
            }

            .goodsInfo {
                color: rgb(103, 107, 124);
                flex: 1;

                .goodsName {
                    text-align: left;
                    height: 47px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;

                    span {
                        cursor: pointer;
                    }

                    span:hover {
                        text-decoration: underline;
                        color: #EC212D;
                    }
                }

                .goodsExplain {
                    width: 100%;
                    height: 20px;
                    text-align: left;
                    font-size: 12px;
                    font-weight: 400;
                    color: #777;
                    box-sizing: border-box;
                    padding: 0 30px 0 0px;

                    >div {
                        height: 22px;
                    }

                    .el-icon-edit {
                        font-size: 18px;
                        cursor: pointer;
                    }

                    .code {
                        cursor: pointer;
                    }

                }
            }
        }
  }
    .order-money{
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      box-sizing: border-box;
      padding-right: 20px;
      font-size: 16px;
      font-family: SimSun;
      font-weight: 400;
      color: #333333;
      span{
        font-size: 24px;
        font-family: DIN;
        font-weight: 500;
        color: #EC212D;
        margin-top: -5px;
        margin-right: 5px;
      }
    }
  }
</style>
